<template>
	<div class="posterBox">
		<div class="loop">
		  <Carousel 
		  	:interval="4000"
		  	indicator-position="none"
		  	:autoplay="true"
		  	arrow="always"
		  	:type="isPc? 'card' : ''"
		  	:height="isPc? '280px' : '200px'">
		    <el-carousel-item v-for="(item, index) in conPic" :key="index">
		    	<!-- <img class="posterimg" :src="item.url" alt=""> -->
		      <div class="posterbg" :style="{'backgroundImage': `url(${item.url})`}"></div>
		    </el-carousel-item>
		  </Carousel>
	  </div>
	</div>
</template>
<script>
import { Carousel } from 'element-ui'
export default {
  components: {
    Carousel
  },
	data () {
		return {
			conPic: [
			  {url: 'https://static001.geekbang.org/resource/image/86/e4/8643bbe93c429e5b6bdecfc049854be4.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/74/05/748943d218abb465ccae2c6f6ef9f705.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/35/d7/352dd1bb56dff68326ec82205f61cdd7.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/84/30/84090122ac93f1d9eb951696318a7430.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/9c/02/9c5cdbb40d166f0268dd042fac00d802.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/8d/e7/8d2ba12c9c00a4123877d995b07b6ce7.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/f9/96/f985e124df468a97d5d6cf1f5357dd96.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/40/a7/40375d2307ae7aed26992b7dd46358a7.jpeg'},
			  {url: 'https://static001.geekbang.org/resource/image/25/75/2565f8529513527737d3760d1e414175.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/d5/e8/d546dfe6af8c1a0a740a5aad80c6efe8.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/00/1e/0014b0ad1d98ab43c6c66708f02c7c1e.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/b3/b6/b3654806e7206033e1666c3c3949e2b6.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/07/a6/073b2d41beb3ea0defc9c2187901bfa6.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/0e/67/0e859789bc36a4de4deadc9f4805e067.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/5b/e7/5b5f3878b9ca75a151cb537c5c01d5e7.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/f8/29/f86460e13039cb9f412792101c5f9329.jpg'},
			  {url: 'https://static001.geekbang.org/resource/image/f3/69/f3b006a69b2daeb8814996c682908569.jpg'},			  
			  {url: 'https://static001.geekbang.org/resource/image/1b/3e/1b67fa108ef3748c858fc671c471173e.jpg'}
			],
			isPc: true
		}
	},
	created () {
		this.init()
	},
	methods: {
		init () {
			var os = function() {
		     var ua = navigator.userAgent,
		     isWindowsPhone = /(?:Windows Phone)/.test(ua),
		     isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, 
		     isAndroid = /(?:Android)/.test(ua), 
		     isFireFox = /(?:Firefox)/.test(ua), 
		     isChrome = /(?:Chrome|CriOS)/.test(ua),
		     isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
		     isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		     isPc = !isPhone && !isAndroid && !isSymbian;
		     return {
		          isTablet: isTablet,
		          isPhone: isPhone,
		          isAndroid : isAndroid,
		          isPc : isPc
		     };
			}()
			this.isPc = (os.isAndroid || os.isPhone) ? false : true
		}
	}
}
</script>
<style lang="sass">
=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.posterBox
	width: 100%
	.loop
		width: 100%
.posterimg
	width: 100%
	height: 100%
.posterbg
	width: 100%
	height: 100%
	background-repeat: no-repeat
	background-position: center
	background-color: #e4e4e4
	background-size: 100%
.el-icon-arrow-right:before
	font-size: 28px
.el-icon-arrow-left:before
	font-size: 28px
</style>



// WEBPACK FOOTER //
// src/components/subloop/subloop.vue